/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Academy_Status_LockedInputs */

const en_academy_status_locked = /** @type {(inputs: Academy_Status_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Locked`)
};

const ja_academy_status_locked = /** @type {(inputs: Academy_Status_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロック済み`)
};

const fr_academy_status_locked = /** @type {(inputs: Academy_Status_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verrouillé`)
};

const de_academy_status_locked = /** @type {(inputs: Academy_Status_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesperrt`)
};

/**
* | output |
* | --- |
* | "Locked" |
*
* @param {Academy_Status_LockedInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const academy_status_locked = /** @type {((inputs?: Academy_Status_LockedInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Academy_Status_LockedInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_academy_status_locked(inputs)
	if (locale === "ja") return ja_academy_status_locked(inputs)
	if (locale === "fr") return fr_academy_status_locked(inputs)
	return de_academy_status_locked(inputs)
});